var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack6Solid06({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.52,5.84,9.06,6a1.07,1.07,0,0,0-.28-.67.81.81,0,0,0-.58-.21,1,1,0,0,0-.81.43A3.61,3.61,0,0,0,7,7.34a1.75,1.75,0,0,1,1.4-.67A2.14,2.14,0,0,1,10,7.39a2.61,2.61,0,0,1,.68,1.86A2.69,2.69,0,0,1,10,11.19a2.45,2.45,0,0,1-1.82.73,2.42,2.42,0,0,1-2-.93,4.72,4.72,0,0,1-.77-3,4.83,4.83,0,0,1,.8-3.12,2.6,2.6,0,0,1,2.08-1,2.16,2.16,0,0,1,1.48.5A2.31,2.31,0,0,1,10.52,5.84ZM7.1,9.13a1.71,1.71,0,0,0,.34,1.14,1,1,0,0,0,.77.4.89.89,0,0,0,.7-.33,1.65,1.65,0,0,0,.28-1.08,1.72,1.72,0,0,0-.3-1.12.94.94,0,0,0-.75-.36,1,1,0,0,0-.74.34A1.5,1.5,0,0,0,7.1,9.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack6Solid06);
export default __webpack_public_path__ + "static/media/Symbolpack_6_solid_06.7d1b5f47d5332b3689e273bfa60f6351.svg";
export { ForwardRef as ReactComponent };